'use es6';

import { PureComponent, Fragment } from 'react';
import { connect } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FieldTypes } from 'ui-forms-components/constants/FieldTypeMapping';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import { StepperInput } from 'foundations-components/transitional/components/StepperInput';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
import { getPropertyObjectTypeId } from 'FormsUI/utils/PropertiesUtils';
import { CommentableArea } from 'collaboration-sidebar';
import ConfigurationPropertyOptionsTableWrapper from 'FormsUI/components/editor/form/configuration/ConfigurationPropertyOptionsTableWrapper';
import getMetaDataValue from 'forms-utils-lib/formField/utils/getMetaDataValue';
import updateFormFieldKey from 'forms-utils-lib/formField/utils/updateFormFieldKey';
import FormFieldKeys from 'forms-utils-lib/constants/formField/FormFieldKeys';
import updateMetaData from 'forms-utils-lib/formField/utils/updateMetaData';
import { Spacer } from 'foundations-components/components/Spacer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const langKey = suffix => `editor.form.config.${suffix}`;
const NUM_COLUMNS_KEY = 'numColumns';
const DEFAULT_VALUE_COLUMNS = 1;
const MIN_VALUE = 2;
const MAX_VALUE = 3;
class Enumeration extends PureComponent {
  maybeRenderColumnOptions() {
    const {
      shouldRenderColumnOptions,
      field,
      update
    } = this.props;
    if (!shouldRenderColumnOptions) {
      return null;
    }
    const currentValue = parseInt(getMetaDataValue(field, NUM_COLUMNS_KEY), 10);
    const toggleUpdateValue = currentValue ? null : `${DEFAULT_VALUE_COLUMNS + 1}`;
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "config-input-field",
      children: /*#__PURE__*/_jsxs(TFlex, {
        children: [/*#__PURE__*/_jsx(CommentableArea, {
          moduleId: `${getPropertyObjectTypeId(field)}-spread-to-columns-toggle`,
          description: {
            translationKey: 'formsSpreadToColumnsToggle'
          },
          children: /*#__PURE__*/_jsx(Box, {
            grow: "1",
            children: /*#__PURE__*/_jsx(FormControl, {
              label: /*#__PURE__*/_jsx(FormattedMessage, {
                message: langKey('spreadToColumnsToggle')
              }),
              children: /*#__PURE__*/_jsx(Toggle, {
                checked: currentValue,
                onChange: () => update(updateMetaData(field, NUM_COLUMNS_KEY, toggleUpdateValue)),
                "data-editable-field": "column-spread"
              })
            })
          })
        }), /*#__PURE__*/_jsx(CommentableArea, {
          moduleId: `${getPropertyObjectTypeId(field)}-number-of-columns`,
          children: /*#__PURE__*/_jsx(Box, {
            grow: "1",
            children: /*#__PURE__*/_jsx(FormControl, {
              label: /*#__PURE__*/_jsx(FormattedMessage, {
                message: langKey('numberOfColumnsInput')
              }),
              children: /*#__PURE__*/_jsx(StepperInput, {
                min: MIN_VALUE,
                max: MAX_VALUE,
                disabled: !currentValue,
                value: currentValue || DEFAULT_VALUE_COLUMNS,
                onChange: ({
                  target: {
                    value
                  }
                }) => {
                  update(updateMetaData(field, NUM_COLUMNS_KEY, `${value}`));
                },
                "data-editable-field": "num-columns"
              })
            })
          })
        })]
      })
    });
  }
  renderOptions() {
    const {
      field,
      update
    } = this.props;
    return /*#__PURE__*/_jsx(ConfigurationPropertyOptionsTableWrapper, {
      formField: field,
      handleUpdate: update
    });
  }
  render() {
    const {
      field,
      update,
      hasPlaceholder
    } = this.props;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [this.props.RequiredField, this.props.HiddenField, this.props.LabelField, /*#__PURE__*/_jsx(Spacer, {}), hasPlaceholder && this.props.renderPlaceholderField({
        value: field.unselectedLabel,
        update: newValue => update(updateFormFieldKey(field, FormFieldKeys.UNSELECTED_LABEL, newValue)),
        field
      }), this.renderOptions(), /*#__PURE__*/_jsx(Spacer, {}), this.props.HelpTextField, /*#__PURE__*/_jsx(Spacer, {}), this.props.ProfillingField, /*#__PURE__*/_jsx(Spacer, {}), this.maybeRenderColumnOptions()]
    });
  }
}
const mapStateToProps = (state, {
  field
}) => {
  const hasPlaceholder = [FieldTypes.SELECT].indexOf(field.fieldType) > -1;
  return {
    hasPlaceholder
  };
};
const actionCreators = {};
export default connect(mapStateToProps, actionCreators)(Enumeration);